import { useSession } from '../Components/Session';
import { useUnreadThreads } from './Messages';
import { useLiveUnreadThreads } from './Local/Message/hooks';
import { useDataSource, resolveSource } from './Local/dataSource';
import messageFeed from './Local/Message/feed';
import { Roles } from './Users';

const useHomeBadge = () => {
    const {notificationBadge, isRoleSufficient} = useSession();
    const isManager = isRoleSufficient(Roles.Manager);
    const source = useDataSource(messageFeed.name);
    const isLocal = source.isLocal && isManager;

    // Where the device holds the unread counts, asking the API for them again is
    // the one call this badge doesn't need to make.
    const api = useUnreadThreads(!isManager || isLocal);
    const local = useLiveUnreadThreads(isLocal);
    const {data: unread} = resolveSource({...source, isLocal}, {
        local: local?.unread,
        api: api.unread,
    });

    const inboxBadge = unread?.length > 0;

    return inboxBadge || notificationBadge;
}

export default useHomeBadge;
